import React, { useState, useEffect } from "react";
import { SearchInput } from "../../Components";
import { SelectInput, Pagination } from "../../Components";
import {
  arrowLeft,
  download,
  plusIcon,
  searchIcon,
} from "../../Components/Base/SVG";
import NotifMainItem from "./NotifMainItem";
import { NotifSystemModul } from "./NotifModul";

const selectDescList = [
  { id: "title", value: "Title" },
  { id: "message", value: "Text" },
  { id: "assigned", value: "Assigned" },
  { id: "created_at", value: "Date" },
  { id: "status", value: "Status" }
];
export default function NotifSystem({ searchText, search, changeMediumDesc, setTab, setTabData, tabData, paginationData, onPaginate, downloadCsv, setSearchTextOnChange }) {
  useEffect(() => {
    const keyDownHandler = event => {
      console.log("sdds")
      if (event.key === 'Enter') {
        search();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [searchText]);
  return (
    <div className="admnotif">
      <div className="admnotif__table-title">
        <div className="admnotif__table-title-info">
          <button
            className="button tertiary big"
            onClick={() => setTab("systemAdd")}
          >
            Create notification {plusIcon}
          </button>
          <button
            className="button tertiary big left"
            onClick={() => setTab("main")}
          >
            {arrowLeft} Back to notification list
          </button>
        </div>
        <div className="admnotif__table-title-inner">
          <SelectInput
            list={selectDescList}
            selected={selectDescList[0]}
            onChange={changeMediumDesc}
          />

          <SearchInput
            value={searchText}
            onClick={search}
            type="text"
            icon={searchIcon}
            placeholder="Search"
            onChange={setSearchTextOnChange} />
        </div>
      </div>

      <div className="admnotif__table">
        <table>
          <thead>
            <tr>
              <th>Id</th>
              <th>Title</th>
              <th>Text</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {tabData.map((item, index) => {
              return (
                <NotifMainItem
                  onClick={() => {
                    if (index === 0) {
                      setTab("systemEditOppr");
                    } else {
                      setTab("systemEditPay");
                    }

                    setTabData(item);
                  }}
                  tab="system"
                  key={index}
                  {...item}
                />
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="admnotif__table-footer">
        <button className="button tertiary download" onClick={downloadCsv}>
          Download CSV {download}
        </button>
        <Pagination
          perPage={paginationData['per_page']}
          total={paginationData['total']}
          currentPage={paginationData['current_page']}
          totalPages={paginationData['total_pages']}
          onPaginate={onPaginate}
        />
      </div>
    </div>
  );
}
